// Landing-page helpers: "buy" buttons scroll to the product form; the sticky bar shows once the form is off screen.
(() => {
  if (window.lpInit) return;
  window.lpInit = true;

  const buyBox = () => document.querySelector('product-info') || document.querySelector('[id^="MainProduct-"]');

  document.addEventListener('click', (event) => {
    const button = event.target.closest('.js-lp-buy');
    if (!button) return;
    const target = buyBox();
    if (!target) return;
    event.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  const start = () => {
    const bar = document.querySelector('[data-lp-sticky]');
    if (!bar) return;
    const update = () => {
      const form = document.querySelector('.product-form__buttons') || buyBox();
      bar.classList.toggle('is-visible', !!form && form.getBoundingClientRect().bottom < 0);
    };
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
